import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=7a89fc1f&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/ringg_deliveryhub-app_production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a89fc1f"]])

export default __exports__